// extracted by mini-css-extract-plugin
export default {"status":"_2V_jUmSJzY2hHhTHQtobgo","statusText":"_3P72pAmZ8yWwaFw4Rf4Rko","red":"_19V5RssspAKTbN0-lfzsL3","green":"ZFXJ1ydHaFTqgMALfAAWJ","blue":"_2rkQsHTLqK9DAj3u8KojNF"};